import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CircleCheck } from "lucide-react";
export default function EquipmentHero() {
  const trustBadges = ["זמינות מיידית 24/7", "פריסה ארצית רחבה", "צוות מקצועי ומיומן"];
  return <section data-section-id="259176" id="מטפל-סיעודי-בפתח-תקווה-פתרון-מיידי" className="relative flex min-h-[70vh] items-center justify-center overflow-hidden bg-background py-24 text-center md:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/petah_tikva_care_bg.png')] bg-cover bg-center bg-no-repeat opacity-10 mix-blend-luminosity" />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/90 to-background/60" />

      <div className="container relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 md:px-6">
        <h1 className="mb-6 font-default text-6xl font-bold tracking-tight text-primary md:text-8xl lg:text-9xl">
          מטפל סיעודי בפתח תקווה תוך 5 שעות
        </h1>

        <p className="mb-10 max-w-2xl text-lg text-muted-foreground md:text-xl font-default">
          זקוקים לעזרה דחופה? אנו מספקים מענה סיעודי מקצועי ומיידי בכל רחבי פתח תקווה. 
          מטפלים מנוסים המגיעים אליכם הביתה או לבית החולים במהירות שיא.
        </p>

        <div className="mb-16 flex w-full flex-col justify-center gap-4 sm:w-auto sm:flex-row">
          <Button asChild size="lg" className="h-14 rounded-md px-8 text-lg font-semibold bg-primary text-primary-foreground shadow-lg">
            <Link to="/CaregiverServicePagesPage">מטפל סיעודי בבית</Link>
          </Button>
          <Button asChild size="lg" className="h-14 rounded-md px-8 text-lg font-semibold bg-secondary text-secondary-foreground shadow-md">
            <Link to="/NurseInTelAvivWithinHoursPage">מטפל סיעודי בתל אביב</Link>
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-medium text-foreground/90 md:text-base font-default">
          {trustBadges.map((badge, i) => <div key={i} data-index={i} className="flex items-center gap-2">
              <CircleCheck className="h-5 w-5 text-chart-2" />
              <span>{badge}</span>
            </div>)}
        </div>
      </div>
    </section>;
}